import React, {useContext} from "react"
import UserContext from "../firelib/user-context"

const PROPERTY_ID = process.env.GATSBY_PROPERTY_ID   
const gtag = window && window.gtag

export default function GtagSetup({children}){
    const {user} = useContext(UserContext)
    const element = <>{children}</>
    if (!user || !gtag){
        return element
    }

    gtag('config', PROPERTY_ID, {
        'user_id': user.uid
    })

    return element
}